import PropTypes from "prop-types";
import { useLocation, Redirect } from "react-router-dom";
import CmsApi from "@apis/CmsApi";

import LoadingSpinner from "./LoadingSpinner";
import EntityRenderer from "./EntityRenderer";
import useSWR from "swr";
import PrerenderIoHelper from "../helpers/PrerenderIoHelper";

import HelmetBuilder from "@/base/HelmetBuilder";
// might expand to fetch entities by other methods later?
const EntityFetcher = ({ preview }) => {

  let path = useLocation().pathname;
  let isPreview = path.includes('/preview');
  let fetchPath = isPreview ? path.replace('/preview', '') : path;

  let fetchFunction;
  if (isPreview) {
    fetchFunction = new CmsApi().fetchPreviewByPath(fetchPath)
  } else {
    fetchFunction = new CmsApi().fetchEntityByPath(fetchPath)
  }

  const { data, error } = useSWR(
    fetchPath,
    () => fetchFunction,
    {
      revalidateOnFocus: false,
    }
  );

  const entity = { ...data, isLoading: !data && !error, isError: error };

  if (entity.isLoading) {
    return <div css={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><LoadingSpinner /></div>;
  }

  if (entity.isError || !entity.data.elements) {
    console.error(error);
    PrerenderIoHelper.isReady(false).notFound();
    return <Redirect to="/404" />;
  }

  return (
    <>
      {entity?.data && <HelmetBuilder data={entity.data} preview={preview} />}
      <EntityRenderer entity={entity.data} />
    </>
  )
};

EntityFetcher.propTypes = {
  preview: PropTypes.bool
};

export default EntityFetcher;
